// MODULES
import * as HTTP from '@getgo/webinar.com-frontend-redux/lib/helpers/httpService';
import config from 'config';

// Helpers
import { appLogger } from 'app-lib/helpers/logging';

const logger = appLogger.create('event-capture-service');

// method to send events to eventCaptureService (featureServices)
export function send(eventName = '', eventBody = {}) {
    // create header
    const header = {
        'Content-Type': 'application/json',
    };
    // build the url
    const url = config.featureServices.baseUrl + config.featureServices.eventCaptureService.createEventPath;
    // create event
    const event = {
        eventName,
        eventBody,
        eventType: config.featureServices.eventCaptureService.eventType,
        eventVersion: config.featureServices.eventCaptureService.eventVersion,
        eventTime: Date.now(),
        eventSource: config.featureServices.eventCaptureService.eventSource,
        namespace: config.featureServices.eventCaptureService.namespace
    };
    // send to eventCaptureService
    return HTTP
        .postData(url, header, event)
        .catch((err) => logger.error('error sending data to event capture service', { event, url, err }));
}



// WEBPACK FOOTER //
// ./src/app-lib/events/event-capture-service.js